/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A service team within the organization
 * @export
 * @interface ServiceTeamSummary
 */
export interface ServiceTeamSummary {
    /**
     * The name of the service team
     * @type {string}
     * @memberof ServiceTeamSummary
     */
    name?: string;
    /**
     * The description of the service team
     * @type {string}
     * @memberof ServiceTeamSummary
     */
    description?: string;
    /**
     * The number of primary members in the service team
     * @type {number}
     * @memberof ServiceTeamSummary
     */
    primaryMemberCount?: number;
    /**
     * The total number of all members in the service team (primary and non-primary)
     * @type {number}
     * @memberof ServiceTeamSummary
     */
    totalMemberCount?: number;
}

/**
 * Check if a given object implements the ServiceTeamSummary interface.
 */
export function instanceOfServiceTeamSummary(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceTeamSummaryFromJSON(json: any): ServiceTeamSummary {
    return ServiceTeamSummaryFromJSONTyped(json, false);
}

export function ServiceTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTeamSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'primaryMemberCount': !exists(json, 'PrimaryMemberCount') ? undefined : json['PrimaryMemberCount'],
        'totalMemberCount': !exists(json, 'TotalMemberCount') ? undefined : json['TotalMemberCount'],
    };
}

export function ServiceTeamSummaryToJSON(value?: ServiceTeamSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'PrimaryMemberCount': value.primaryMemberCount,
        'TotalMemberCount': value.totalMemberCount,
    };
}

